import { DynamicLinkProps } from 'packages/smart-home-support/components/DynamicLink';
import getPartnerAsset, { DynamicAssetsKeys } from 'packages/smart-home-support/assets';
import { getPartner } from 'packages/smart-home-support/partner';
import { theme } from 'packages/smart-home-support/themes';
import { getQueryStringParsed, openChat, phoneToUrl, updateQueryString, noop } from 'packages/smart-home-support/utils';
import BREAK_POINTS from 'packages/smart-home-support/styling/media-queries';
import { TabKey } from './models';
import { BASE_PATH } from './constants';

const { expertSessionsPath, helpNumber } = getPartner();

export const getChatLinkProps = (): Partial<DynamicLinkProps> => {
  const isExpertChatSdkEnabled = getPartnerAsset(DynamicAssetsKeys.expertChatSdkEnabled);
  const chatUrl = getPartnerAsset(DynamicAssetsKeys.chatUrl);
  return isExpertChatSdkEnabled ? { onClick: openChat } : { to: chatUrl, target: '_blank' };
};

export const getExpertSessionsUrl = () => expertSessionsPath;

export const getPhoneUrl = () => phoneToUrl(helpNumber);

export const getUrl = (path?: string) => `${BASE_PATH}${path ? '/' : ''}${path || ''}`;

export const getTabUrl = (tab: TabKey) => getUrl(`?tab=${tab}`);

export const getAccentColor = () => theme.colors.dashboardAccent || theme.colors.primaryAccent;

export const getBreakpoint = () => BREAK_POINTS.desktop;

export { getQueryStringParsed, updateQueryString, noop };



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/utils.tsx